import React, { useState, useEffect } from "react";
import "./backoffice.css";
import { Navigate, Route, Routes } from "react-router-dom";
import BoSidebar from "../Sidebar/BoSidebar";
import BoHeader from "../Header/BoHeader";
import Dashboard from "../Dashboard/Dashboard";
import RestaurantApprovals from "../RestaurantApprovals/RestaurantApprovals";
import Reports from "../Reports/Reports";
import api from "../../services/api";
import { useDispatch } from "react-redux";
import { setRequestApproval } from "../../redux/Slice/requestApproval";
import SupportEscalations from "./SupportEscalations/SupportEscalations";
import useSupportWebSocket from "../../hooks/useSupportWebSocket";
function BackOfficePagesIntegration() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const dispatch = useDispatch();

  // Initialize WebSocket connection for Back-Office
  useSupportWebSocket('back-office');

  // Close sidebar if screen width is less than 1024px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsSidebarOpen(false); // Automatically close the sidebar
      } else {
        setIsSidebarOpen(true); // Keep sidebar open for larger screens
      }
    };

    handleResize(); // Call on initial render
    window.addEventListener("resize", handleResize); // Add resize listener

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup listener
    };
  }, []);

  function fetchResturantApprovals() {
    api
      .get("/getresaurantApprovals")
      .then((res) => {
        console.log(res.data.vendor);
        dispatch(setRequestApproval(res.data.vendor));
      })
      .catch((err) => {
        console.log(err);
      });
  }
  useEffect(() => {
    fetchResturantApprovals();
  }, []);
  return (
    <div className="BackOfficePagesInteegrationMainClass">
      {isSidebarOpen && <BoSidebar />}

      <div className="RightContent">
        <BoHeader setIsSidebarOpen={setIsSidebarOpen} />
        <h1>content</h1>
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="/" element={<Navigate to={"dashboard"} />} />

          <Route
            path="restaurants-approvals"
            element={<RestaurantApprovals />}
          />
          <Route
            path="payments-management"
            element={<h1>Payment Management</h1>}
          />
          <Route path="reports" element={<Reports />} />
          <Route path="support-escalations/*" element={<SupportEscalations />} />
        </Routes>
      </div>
    </div>
  );
}

export default BackOfficePagesIntegration;
